import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(
    () => ({
        /* Styles applied to the root element if `variant="top"`. */
        variantTop: {
            top: '0',
        },
        /* Styles applied to the root element if `variant="bottom"`. */
        variantBottom: {
            top: 'auto',
            bottom: 0,
        },
    }),
    { name: 'MuiAppBar' },
);

export default useStyles;
